import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import { EventType } from "pages/statuses/EventType";
import { CollectionRequestForm } from "pages/booking/dialogParts/CollectionRequestForm";
import { BookingConfirmItems } from "pages/booking/dialogParts/BookingConfirmItems";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            margin: theme.spacing(5),
            marginBottom: theme.spacing(1),
            color: `black`,
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
    // ローディング状態のセッター
    setLoading: any;
}

/**
 * 予約確認コンポーネント
 * 予約確認画面のコンポーネント
 */
export const ConfirmParts: React.FC<Props> = (props) => {
    const { booking, setLoading } = props;
    const classes = useStyles();

    return (
        <div className={classes.form}>
            <BookingConfirmItems booking={booking} />
            <CollectionRequestForm booking={booking} mode={`confirm`} setLoading={setLoading} />
            <div>
                <TextField
                    margin="dense"
                    id="memo"
                    label="備考"
                    type="text"
                    value={booking.subscriberMemo}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
            </div>
            <div>
                <TextField
                    margin="dense"
                    id="numberOfChemicals"
                    label="廃薬品数"
                    type="text"
                    value={booking.numberOfChemicals ? booking.numberOfChemicals : 0}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
            </div>
        </div>
    );
};
